import { render, staticRenderFns } from "./Treballadors.vue?vue&type=template&id=d1145378&"
import script from "./Treballadors.vue?vue&type=script&lang=js&"
export * from "./Treballadors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports